import type { AssetType, WeightedSecurity } from '@fruitful/types';
import {
    BadgeLabel,
    type BadgeLabelVariant,
    BodyMediumRegular,
    View,
    XStack,
    YStack,
} from 'smoothie';

const ASSET_COLORS: Record<AssetType, BadgeLabelVariant> = {
    equities: 'green',
    fixedIncome: 'blue',
    cash: 'marigold',
    unassigned: 'gray',
};

export const PortfolioAssetCategory = ({
    name,
    securities,
    type,
}: {
    securities: WeightedSecurity[];
    name: string;
    type: AssetType;
}) => {
    return (
        <YStack width="100%" borderTopLeftRadius={24} borderTopRightRadius={24}>
            <XStack
                borderTopLeftRadius={24}
                borderTopRightRadius={24}
                backgroundColor="$gray200"
                padding={16}
            >
                <BodyMediumRegular>{name}</BodyMediumRegular>
            </XStack>
            <YStack padding={16} backgroundColor="$white" width="100%" gap={24}>
                {securities
                    .sort((a, b) => {
                        return b.weight - a.weight;
                    })
                    .map(({ assetClass, symbol, weight }: WeightedSecurity) => {
                        const variant = ASSET_COLORS[type];
                        return (
                            <XStack
                                key={symbol + assetClass}
                                alignItems="flex-start"
                                justifyContent="space-between"
                            >
                                <View flex={3}>
                                    <BodyMediumRegular>
                                        {assetClass}
                                    </BodyMediumRegular>
                                </View>
                                <XStack flex={5} justifyContent="flex-end">
                                    <View key={symbol}>
                                        <BadgeLabel
                                            text={symbol ?? 'Unknown'}
                                            variant={variant}
                                        />
                                    </View>
                                    <BodyMediumRegular
                                        textAlign="right"
                                        width={70}
                                    >
                                        {weight}%
                                    </BodyMediumRegular>
                                </XStack>
                            </XStack>
                        );
                    })}
            </YStack>
        </YStack>
    );
};
